/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";

import type { AzukiToken } from "../AzukiToken";

export class AzukiToken__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<AzukiToken> {
    return super.deploy(overrides || {}) as Promise<AzukiToken>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): AzukiToken {
    return super.attach(address) as AzukiToken;
  }
  connect(signer: Signer): AzukiToken__factory {
    return super.connect(signer) as AzukiToken__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): AzukiToken {
    return new Contract(address, _abi, signerOrProvider) as AzukiToken;
  }
}

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "newMinter",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "releaseTime",
        type: "uint256",
      },
    ],
    name: "GonnaAddMinter",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "releaseTime",
        type: "uint256",
      },
    ],
    name: "GonnaLockTransfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "releaseTime",
        type: "uint256",
      },
    ],
    name: "GonnaMint",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "burnRate",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "mintAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "mintTo",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "minters",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "newMinter",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    name: "operationLockTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    name: "operationTimelockEnabled",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unlockDuration",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "gonnaMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "releaseMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "addMinter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "removeMinter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "gonnaAddMinter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "releaseNewMinter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "gonnaLockTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "releaseTransferLock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "duration",
        type: "uint256",
      },
    ],
    name: "changeTimelockDuration",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "lockMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "lockAddMinter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "addToWhitelist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "removeFromWhitelist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unlockTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
